import Vue from "vue";
import Vuex from "vuex";
import { getField, updateField } from "vuex-map-fields";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [],
    state: {
        config: {
            baseUrl: "",
        },
        searchApp: {
            state: {
                hasSearched: false,
                loading: false,
            },
            search: {
                selectedCategories: ['All'],
                publishedAfter: "",
                publishedBefore: "",
                sort: "",
                searchText: "",
                start: 0,
            },
            searchOptions: {
                categoryList: [],
            },
            lastSearchedFor: {
                selectedCategories: [],
                publishedAfter: "",
                publishedBefore: "",
                sort: "",
                searchText: "",
            },
            searchResult: {
                totalResults: 0,
                currentPage: 0,
                totalPages: 0,
                nextStart: null,
                prevStart: null,
                results: [],
            },
            featuredArticle: {
                id: "",
                title: "",
                date: "",
                link: "",
                summary: "",
                imageUrl: "",
            },
            initialArticles: [],
            articlePagination: {
                currentPage: 0,
                totalPages: 0,
            },
            headerSearchPanelOpen: false,
        },
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
    },
    actions: {

        async submitSearch({ state, commit }) {

            // debugger;
            let url = new URL(window.location.href);
            let params = new URLSearchParams(url.search);

            const paramNames = ["selectedCategories", "sort", "searchText", "start"];

            // set params from search state
            for (const paramName of paramNames) {
                params.set(paramName, state.searchApp.search[paramName]);
            }

            //todo make sure to parse quotes and other special characters
            url.search = params.toString();
            let newUrl = url.toString();
            window.history.pushState({ path: newUrl }, "", newUrl);

            commit("updateField", {
                path: "searchApp.state.loading",
                value: true,
            });

            let selectedCategories = state.searchApp.search.selectedCategories;

            if (Array.isArray(selectedCategories)) {
                // already an array → do nothing
            } else if (typeof selectedCategories === "string") {
                selectedCategories = selectedCategories.split(',').map(s => s.trim());
            } else {
                selectedCategories = []; // fallback
            }

            commit("updateField", {
                path: "searchApp.lastSearchedFor.selectedCategories",
                value: selectedCategories,
            });

            commit("updateField", {
                path: "searchApp.lastSearchedFor.sort",
                value: state.searchApp.search.sort,
            });

            commit("updateField", {
                path: "searchApp.lastSearchedFor.searchText",
                value: state.searchApp.search.searchText,
            });

            const currentUrl = window.location.origin + window.location.pathname.replace(/\/$/, "");
            const searchUrl = `${currentUrl}/search`;

            return await axios
                .post(searchUrl, state.searchApp.search)
                .then((response) => {
                    console.log(response);
                    if (response.data) {
                        commit("updateField", {
                            path: "searchApp.searchResult",
                            value: response.data,
                        });
                    }

                    commit("updateField", {
                        path: "searchApp.state.loading",
                        value: false,
                    });
                    commit("updateField", {
                        path: "searchApp.state.hasSearched",
                        value: true,
                    });
                })
                .catch((error) => {
                    console.log(error);
                    commit("updateField", {
                        path: "searchApp.state.loading",
                        value: false,
                    });
                    commit("updateField", {
                        path: "searchApp.state.hasSearched",
                        value: true,
                    });
                });
        },
        resetSearch({ commit }) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete("selectedCategories");
            currentUrl.searchParams.delete("sort");
            currentUrl.searchParams.delete("searchText");
            window.history.replaceState({}, '', currentUrl.toString());

            commit("updateField", {
                path: "searchApp.state.loading",
                value: false,
            });

            commit("updateField", {
                path: "searchApp.search",
                value: {
                    selectedCategories: [],
                    publishedAfter: "",
                    publishedBefore: "",
                    sort: "",
                    searchText: "",
                    start: 0,
                },
            });

            commit("updateField", {
                path: "searchApp.lastSearchedFor",
                value: {
                    selectedCategories: [],
                    publishedAfter: "",
                    publishedBefore: "",
                    sort: "",
                    searchText: "",
                },
            });

            commit("updateField", {
                path: "searchApp.searchResult",
                value: {
                    totalResults: 0,
                    currentPage: 0,
                    totalPages: 0,
                    nextStart: null,
                    prevStart: null,
                    results: [],
                },
            });
        },

        async fetchArticles({ commit }, page = 1) {
            // only called if on news/media page
            // based on presence of a class on the app

            const currentUrl = window.location.origin + window.location.pathname.replace(/\/$/, "");
            const articleUrl = `${currentUrl}/articles`;

            commit("updateField", {
                path: "searchApp.state.loading",
                value: true,
            });

            // scroll page to c-articles
            const articlesElement = document.getElementById("site-search-app");
            if (articlesElement) {
                articlesElement.scrollIntoView({ behavior: "smooth" });
            }

            return await axios
                .post(articleUrl, { page })
                .then((response) => {

                    console.log(response);

                    if (response.data) {
                        if (response.data.featured) {
                            commit("updateField", {
                                path: "searchApp.featuredArticle",
                                value: response.data.featured,
                            });
                        } else {
                            commit("updateField", {
                                path: "searchApp.featuredArticle",
                                value: null,
                            });
                        }

                        commit("updateField", {
                            path: "searchApp.initialArticles",
                            value: response.data.articles,
                        });

                        commit("updateField", {
                            path: "searchApp.articlePagination",
                            value: response.data.pagination,
                        });

                        commit("updateField", {
                            path: "searchApp.state.loading",
                            value: false,
                        });
                        
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }

    },
});